module.exports = __webpack_public_path__ + "static/media/create_reservation_select_floor.6bb8b28f.jpg";